import React, { Component } from "react";
import subDays from "date-fns/subDays";
import { createTheme } from "@material-ui/core";
import InputAdornment from "@material-ui/core/InputAdornment";
import IconButton from "@material-ui/core/IconButton";
import { Autocomplete, TextField } from "@mui/material";
import {
  MuiPickersUtilsProvider,
  DatePicker,
  TimePicker,
} from "@material-ui/pickers";
import { ThemeProvider } from "@material-ui/styles";
import DateFnsUtils from "@date-io/date-fns";
import "./PtsDateTimePicker.css";
import store from "../../../redux/store";
import { BUSINESS_DOMAIN } from "../../../provider/Enums";

/* ---------- Theme ---------- */
const materialTheme = createTheme({
  overrides: {
    MuiPickersToolbar: {
      toolbar: {
        backgroundColor: "#008181",
      },
    },
    MuiPickersCalendarHeader: {
      switchHeader: {
        backgroundColor: "white",
        color: "#005476",
      },
    },
  },
});

/* ---------- Component ---------- */
class PtsDateTimePicker extends Component {
  eventBusinessDomain = store.getState().businessDomain?.eventState;
  businessDomain =
    store.getState().appUserData.appUserData.appuser?.businessDomain;

  constructor(props) {
    super(props);
    const scheduled = props.value ? new Date(props.value) : null;

    this.state = {
      hour: scheduled
        ? String(
          scheduled?.getHours() % 12 === 0 ? 12 : scheduled?.getHours() % 12
        )?.padStart(2, "0")
        : null,

      minute: scheduled
        ? String(scheduled?.getMinutes())?.padStart(2, "0")
        : null,

      ampm: scheduled
        ? scheduled?.getHours() >= 12
          ? "pm"
          : "am"
        : null,
      dateTime: props.value,
      onchange: props.onChange,
      pageId: props.ScheduledSend,
      selectedDate: scheduled
        ? new Date(
          scheduled.getFullYear(),
          scheduled.getMonth(),
          scheduled.getDate()
        )
        : null,

      selectedTime: scheduled
        ? new Date(
          1970,
          0,
          1,
          scheduled.getHours(),
          scheduled.getMinutes(),
          0,
          0
        )
        : null,
    };
  }

  getTimeParts = (date) => {
    if (!date) return { hour: null, minute: null, ampm: null };

    const h = date.getHours();
    return {
      hour: String(h % 12 === 0 ? 12 : h % 12).padStart(2, "0"),
      minute: String(date.getMinutes()).padStart(2, "0"),
      ampm: h >= 12 ? "pm" : "am",
    };
  };

  /* ---------- Date change ---------- */
  handleDateChange = (date) => {
    this.setState({ selectedDate: date }, this.emitChange);
  };

  /* ---------- Time change ---------- */
  // handleTimeChange = (time) => {
  //   this.setState({ selectedTime: time }, this.emitChange);
  // };

  handleTimeChange = (field, value) => {
    this.setState(
      {
        [field]: value,
      },
      () => {
        const { hour, minute, ampm } = this.state;

        if (hour && minute && ampm) {
          let h = parseInt(hour);

          if (ampm === "pm" && h !== 12) {
            h += 12;
          }
          if (ampm === "am" && h === 12) {
            h = 0;
          }

          const selectedTime = new Date();
          selectedTime.setHours(h);
          selectedTime.setMinutes(parseInt(minute));
          selectedTime.setSeconds(0);
          this.setState(
            { selectedTime },
            () => this.emitChange && this.emitChange()
          );
        }
      }
    );
  };

  /* ---------- Emit to parent ---------- */
  emitChange = () => {
    const { selectedDate, selectedTime } = this.state;

    if (!this.props.onChange) return;
    if (!selectedDate || !selectedTime) {
      this.props.onChange(null);
      return;
    }

    const merged = new Date(selectedDate);
    merged.setHours(
      selectedTime.getHours(),
      selectedTime.getMinutes(),
      0,
      0
    );

    const isoWithOffset = merged.toISOString().replace("Z", "+00:00");

    this.setState(
      { dateTime: isoWithOffset },
      () => {
        // ✅ state is updated here
        this.props.onChange(this.state);
      }
    );
  };

  /* ---------- Event End Date ---------- */
  getEventEndDateTime = () => {
    if (
      this.businessDomain === BUSINESS_DOMAIN.eventText &&
      this.eventBusinessDomain?.endDate
    ) {
      const endDate = new Date(this.eventBusinessDomain.endDate);
      return isNaN(endDate.getTime()) ? undefined : endDate;
    }
    return undefined;
  };

  /* ---------- Render ---------- */
  render() {
    const hours = Array.from({ length: 12 }, (_, i) =>
      String(i + 1).padStart(2, "0")
    );

    const minutes = Array.from({ length: 60 }, (_, i) =>
      String(i).padStart(2, "0")
    );

    const ampmOptions = ["am", "pm"];

    return (
      <MuiPickersUtilsProvider utils={DateFnsUtils}>
        <ThemeProvider theme={materialTheme}>
          <div className="row d-flex datePickerHelperText">

            {/* DATE */}
            <div className="col-sm-5">
              <DatePicker
                required
                autoComplete="off"
                value={this.state.selectedDate}
                variant="outlined"
                fullWidth
                size="small"
                inputVariant="outlined"
                minDate={subDays(new Date(), 0)}
                maxDate={this.getEventEndDateTime()}
                format="MM/dd/yyyy"
                placeholder="mm/dd/yyyy"
                clearable
                style={{ background: "#fff" }}
                onChange={this.handleDateChange}
                InputProps={{
                  readOnly: true,
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton>
                        <span className="picker-icon">📅</span>
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </div>

            {/* TIME */}
            <div className="col-sm-7 ps-0 pe-0 customTimePicker">
              {/* <TimePicker
                required
                autoComplete="off"
                value={this.state.selectedTime}
                variant="outlined"
                fullWidth
                size="small"
                inputVariant="outlined"
                format="h:mm aa"
                placeholder="hh:mm"
                clearable
                style={{ background: "#fff" }}
                onChange={this.handleTimeChange}
                // disabled={!this.state.selectedDate}
                InputProps={{
                  readOnly: true,
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton>
                        <span className="picker-icon">🕒</span>
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              /> */}
              <div style={{ display: "flex", gap: "10px" }}>

                {/* Hour */}
                <Autocomplete
                  disableClearable
                  autoComplete="off"
                  ListboxProps={{
                    className: "custom-listbox",
                  }}
                  options={hours}
                  value={this.state.hour}
                  onChange={(e, newValue) =>
                    this.handleTimeChange("hour", newValue)
                  }
                  style={{ width: 80 }}
                  renderInput={(params) => (
                    <TextField {...params} required variant="outlined" size="small" placeholder="hh" />
                  )}
                />

                {/* Minute */}
                <Autocomplete
                  disableClearable
                  autoComplete="off"
                  ListboxProps={{
                    className: "custom-listbox",
                  }}
                  options={minutes}
                  value={this.state.minute}
                  onChange={(e, newValue) =>
                    this.handleTimeChange("minute", newValue)
                  }
                  style={{ width: 80 }}
                  renderInput={(params) => (
                    <TextField {...params} required variant="outlined" size="small" placeholder="mm" />
                  )}
                />

                <Autocomplete
                  disableClearable
                  autoComplete="off"
                  ListboxProps={{
                    className: "custom-listbox",
                  }}
                  options={ampmOptions}
                  value={this.state.ampm}
                  onChange={(e, newValue) =>
                    this.handleTimeChange("ampm", newValue)
                  }
                  style={{ width: 90 }}
                  renderInput={(params) => (
                    <TextField {...params} required variant="outlined" size="small" placeholder="am/pm" />
                  )}
                />

              </div>
            </div>

          </div>
        </ThemeProvider>
      </MuiPickersUtilsProvider>
    );
  }
}

export default PtsDateTimePicker;